import React from "react";
import "../scss/Faq.scss";
import Faqs from "../components/Faqs";

const Faqpage = () => {
	return (
		<div className="faq">
			<p className="faq__heading">Have any questions ?</p>
			<div className="faq__questions">
				<Faqs />
			</div>
		</div>
	);
};

export default Faqpage;
